// extracted by mini-css-extract-plugin
export var hideEditor = "_hr-2";
export var infoIcon = "_hr-3";
export var label = "_hr-1";
export var labelContainer = "_hr-0";
export var readonlyText = "_hr-4";